import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Flex, Link, Text, getPaletteColor } from 'pcln-design-system'
import { themeGet } from 'styled-system'

const HeadlineBox = styled(Box)`
  padding: ${props =>
    props.compactText
      ? `${themeGet('space.2')(props)}px ${themeGet('space.1')(
        props
      )}px ${themeGet('space.1')(props)}px ${themeGet('space.1')(props)}px`
      : `${themeGet('space.2')(props)}px ${themeGet('space.2')(
        props
      )}px ${themeGet('space.1')(props)}px ${themeGet('space.2')(props)}px`};
  white-space: ${props => (props.compactText ? 'normal' : 'nowrap')};
  text-align: center;
  width: 100%;

  ${themeGet('mediaQueries.2')} {
    letter-spacing: ${props => (props.compactText ? '1px' : '0px')};
    padding: ${props =>
    props.compactText
      ? `${themeGet('space.3')(props)}px`
      : `${themeGet('space.3')(props)}px ${themeGet('space.4')(props)}px`};
    width: inherit;
  }
`

const StyledHeadline = styled(Text)`
  letter-spacing: ${props => (props.compactText ? '0px' : '1px')};
`

const SubHeadlineBox = styled(Box)`
  border-left: unset;
  font-size: ${themeGet('fontSizes.0')}px;
  padding: ${props =>
    props.compactText
      ? `0 ${themeGet('space.1')(props)}px ${themeGet('space.2')(
        props
      )}px ${themeGet('space.1')(props)}px`
      : `0 ${themeGet('space.2')(props)}px ${themeGet('space.2')(
        props
      )}px ${themeGet('space.2')(props)}px`};
  text-align: center;
  width: 100%;

  ${themeGet('mediaQueries.2')} {
    border-left: 1px solid ${getPaletteColor('background.lightest')};
    font-size: ${themeGet('fontSizes.1')}px;
    padding: ${props =>
    props.compactText
      ? `
      ${themeGet('space.3')(props)}px ${themeGet('space.3')(props)}px
    `
      : `
      ${themeGet('space.3')(props)}px ${themeGet('space.3')(
  props
)}px ${themeGet('space.3')(props)}px ${themeGet('space.4')(props)}px
    `};
    text-align: left;
    width: inherit;
  }
`

const StyledLink = styled(Link)`
  color: ${getPaletteColor('text.lightest')};
  text-decoration: underline;
`

/* istanbul ignore next */
const DesktopSpan = styled('span')`
  display: none;

  ${themeGet('mediaQueries.2')} {
    vertical-align: ${props => (props.compactText ? 'baseline' : 'middle')};
    display: inline-block;
  }
`

const MobileSpan = styled('span')`
  display: inline-block;

  ${themeGet('mediaQueries.2')} {
    display: none;
  }
`

const PromoHeader = ({
  color,
  headline,
  linkText,
  linkUrl,
  mobileHeadline,
  mobileSubheadline,
  subheadline,
  compactText
}) => {
  const link = (
    <>
      {' '}
      <StyledLink href={linkUrl} rel='noopener' target='_blank'>
        {linkText}
      </StyledLink>
    </>
  )

  return (
    <Box>
      <Flex
        color={color}
        flexDirection={['column', null, null, 'row']}
        alignItems='center'
        justifyContent='flex-start'
      >
        <HeadlineBox compactText={compactText}>
          <StyledHeadline
            compactText={compactText}
            caps
            fontSize={0}
            fontWeight='bold'
          >
            <DesktopSpan>{headline}</DesktopSpan>
            <MobileSpan>{mobileHeadline}</MobileSpan>
          </StyledHeadline>
        </HeadlineBox>
        <SubHeadlineBox compactText={compactText}>
          <Text fontWeight={compactText ? '500' : '600'}>
            <DesktopSpan>
              {subheadline}
              {linkUrl && link}
            </DesktopSpan>
            <MobileSpan>
              {mobileSubheadline}
              {linkUrl && link}
            </MobileSpan>
          </Text>
        </SubHeadlineBox>
      </Flex>
    </Box>
  )
}

PromoHeader.propTypes = {
  color: PropTypes.string,
  headline: PropTypes.string,
  linkUrl: PropTypes.string,
  mobileHeadline: PropTypes.string,
  mobileSubheadline: PropTypes.string,
  subheadline: PropTypes.string,
  linkText: PropTypes.string,
  compactText: PropTypes.bool
}

export default PromoHeader
